import User from "../api/model/users/User";
import Barrel from "../model/Barrel";

function getUserDisplayName(user: Pick<User, "email" | "fullName" | "username"> | null | undefined, {
    useUsernameAsFallback = false
} = {}): string {
    if (!user) {
        return "Anonymous";
    }

    const { fullName, username, email } = user;

    const displayName = fullName ?? (useUsernameAsFallback ? username : null) ?? email;

    return displayName ?? "Anonymous";
}

function getHandleText(fullName: string | null | undefined, username: string | null | undefined):
    string | null | undefined {
    if (!username) {
        return "";
    }

    // After the migration fullNames won't be empty
    return fullName;
}

function getHandleTextForSearch(fullName: string | null | undefined, username: string | null | undefined): string {
    if (!username) {
        return "";
    }

    return fullName ? `${fullName}, @${username}` : `@${username}`;
}

function shouldTrackUser(user: typeof Zeplin.user): boolean {
    const { privacyPreferences } = user;

    // If there is no privacyPreferences defined then that means tracking hasn't been opted out yet, so we can track.
    return !privacyPreferences || !privacyPreferences.trackingOptOut.value;
}

function getUniqueMembersCountFromBarrels(barrels: Barrel[]): number {
    return new Set(barrels.reduce<string[]>((allUsers, { users }) =>
        allUsers.concat(users.map(({ user: { _id } }) => _id)), [])
    ).size;
}

export {
    getUserDisplayName,
    getHandleText,
    getHandleTextForSearch,
    shouldTrackUser,
    getUniqueMembersCountFromBarrels
};
